import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import type { ApolloError } from '@apollo/react-hooks';

type GetOVTSRedirectUrl = {
  OVTSRedirectUrl: string;
  loading: boolean;
  error: ApolloError | undefined;
};

const GET_OVTS_REDIRECT_URL = gql`
  query ($applicationId: String!) {
    getOVTSRedirectUrl(applicationId: $applicationId)
  }
`;

export const useGetOVTSRedirectUrl = (
  applicationId: string,
): GetOVTSRedirectUrl => {
  const { data, loading, error } = useQuery(GET_OVTS_REDIRECT_URL, {
    variables: { applicationId },
    fetchPolicy: 'network-only',
    skip: !applicationId,
  });

  const OVTSRedirectUrl = data?.getOVTSRedirectUrl ?? '';

  return {
    OVTSRedirectUrl,
    loading,
    error: error as ApolloError,
  };
};
